import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, UtensilsCrossed, Menu as MenuIcon,
  ReceiptText, FileBarChart, Settings as SettingsIcon, LogOut, X
} from "lucide-react";
import logo from "../assets/lg.png";
import "./Navbar.css";

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: <LayoutDashboard size={18} /> },
    { path: "/tables", label: "Tables", icon: <UtensilsCrossed size={18} /> },
    { path: "/menu", label: "Menu", icon: <MenuIcon size={18} /> },
    { path: "/billing", label: "Billing", icon: <ReceiptText size={18} /> },
    { path: "/reports", label: "Reports", icon: <FileBarChart size={18} /> },
    { path: "/settings", label: "Settings", icon: <SettingsIcon size={18} /> },
  ];

  const isActive = (path) => location.pathname.startsWith(path);

  const handleNav = (path) => {
    navigate(path);
    setMobileOpen(false);
  };

  return (
    <>
      <nav className="top-navbar">
        <div className="navbar-inner-container">
          {/* Logo Container */}
          <div className="navbar-brand-container" onClick={() => navigate("/dashboard")}>
            <img src={logo} alt="Dine Spark" className="navbar-logo" />
          </div>

          {/* Desktop Navigation */}
          <div className="navbar-links">
            {navItems.map((item) => (
              <button
                key={item.path}
                className={`navbar-link-item ${isActive(item.path) ? "nav-item-active" : ""}`}
                onClick={() => handleNav(item.path)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            ))}
          </div>

          {/* Right Actions */}
          <div className="navbar-actions">

          <div className="navbar-divider" />
          <button className="logout-btn-nav" onClick={() => navigate("/")}>
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="mobile-toggle-btn" onClick={() => setMobileOpen(!mobileOpen)}>
          {mobileOpen ? <X size={24} /> : <MenuIcon size={24} />}
        </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`navbar-mobile-overlay ${mobileOpen ? "is-open" : ""}`}>
        <div className="mobile-menu-content">
          {navItems.map((item) => (
            <button
              key={item.path}
              className={`mobile-nav-link ${isActive(item.path) ? "active" : ""}`}
              onClick={() => handleNav(item.path)}
            >
              {item.icon} {item.label}
            </button>
          ))}
          <div className="mobile-divider" />
          <button className="mobile-nav-link logout" onClick={() => navigate("/")}>
            <LogOut size={18} /> Logout
          </button>
        </div>
      </div>
    </>
  );
}

export default Navbar;
